import { MediaType, ExternalAssetSource } from "../../../types";
import { BaseAsset, IAssetMetadata } from "../../base";
import { PolypizzaAsset } from "../types";

export class BasePolypizzaAsset extends BaseAsset {
  protected asset: PolypizzaAsset;

  constructor(file: PolypizzaAsset) {
    super();
    this.asset = file;
  }

  getId(): string {
    return this.asset.ID;
  }

  getName(): string {
    return this.asset.Title;
  }

  setName(_name: string): void {
    // PolyPizza assets are read-only, so this is a no-op
    // In a real implementation, you might throw an error or log a warning
    console.warn('PolyPizza assets cannot be renamed');
  }

  getMediaType() {
    return MediaType.Model3D; // All PolyPizza assets are 3D models
  }

  getImageUrlForCard(size?: { width: number; height?: number }): string {
    if (size) {
      return `${this.asset.Thumbnail}?w=${size.width}&h=${size.height}`;
    }
    return this.asset.Thumbnail;
  }

  getPreviewUrl(size?: { width: number; height?: number }): string {
    return this.getImageUrlForCard(size);
  }

  getDownloadUrl(): string {
    return this.asset.Download;
  }

  downloadFile(): Promise<{ blob: Blob, filename: string }> {
    // This should be implemented to fetch the actual file
    // For now, return a rejected promise as a placeholder
    return Promise.reject(new Error('Download not implemented'));
  }

  downloadFileVersion(versionId: string): Promise<{ blob: Blob, filename: string }> {
    // PolyPizza doesn't support versions, so this is a no-op
    return Promise.reject(new Error('Versioning not supported'));
  }

  getSource(): string {
    return ExternalAssetSource.Polypizza;
  }

  getMetadata(): IAssetMetadata {
    return {
      status: 'ready',
      date: '',
      size: 0,
      categories: this.asset.Category,
      tags: this.asset.Tags,
      licence: this.asset.Licence,
      author: this.asset.Creator.Username,
    };
  }
}
